import { CustomModal } from '../DeleteModal';
import clsx from "clsx";
import { Image, Dropdown, Menu } from "antd";
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import shortCutKeys from "../../../../assets/images/shortCutKeys.png";
import shortCutKeysTitle from "../../../../assets/images/shortCutKeysTitle.svg";
import shortCutDownload from "../../../../assets/images/shortCutDownload.png";
import jsPDF from 'jspdf';



export default function ShortCutKeys(props) {
    const { visible, onClose, classes } = props;

    const handleImageDownload = (type) => {
        const doc = new jsPDF('l', 'px', 'a4');
        doc.addImage(shortCutDownload, 'PNG', 10, 10, doc.internal.pageSize.width - 15, 0, '', '', 0);
        if (type === 'print') {
            doc.autoPrint();
            window.open(doc.output('bloburl'));
        } else {
            doc.save(`Shortcut Keys`);
        }
    }

    return (
        <CustomModal
            visible={visible}
            title={false}
            onClose={() => onClose()}
            customClasses={classes.customShortCutKeys}
            text={<>
                <div className={clsx(classes.customShortCutKeysTitle, classes.bold)}>
                    <span><img src={shortCutKeysTitle} alt="short keys Title" /></span>
                    <div className={classes.hamburgerMenu}>
                        <Dropdown
                            overlayClassName={clsx(classes.customShortCutKeyhamburgerMenu)}
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu)}>
                                    <Menu.Item key={'short_print'}><NavLink to={'#'} onClick={() => handleImageDownload('print')}>Print</NavLink></Menu.Item>
                                    <Menu.Item key={'short_download'}><NavLink to={'#'} onClick={() => handleImageDownload('download')}>Download</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </div>
                </div>
                <div className={clsx(classes.customShortCutKeysContent)}>
                    <img src={shortCutKeys} alt="short keys" />
                </div>
            </>}
        />
    )
}

